import { lazy } from 'react';

const PublicBenefitRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "PublicBenefit" */ '../components/steps/public-benefit-step/PublicBenefit'
    ),
);

export default PublicBenefitRoute;
